// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"642c67b6","238":"01aac47b","330":"8f7e5277","411":"204862e9","424":"8298299b","453":"9a8a2a2f","692":"d4b1fdf2","740":"be5083f1","791":"e1d2dd16","811":"a6327364","841":"915c1a78","909":"0b3e2b8f","987":"779a54fc"}[chunkId] + ".chunk.js";
};